module.exports = __webpack_public_path__ + "img/level-up.253e6866.png";